<template>
  <el-dialog
    @close="closeDialog"
    title="Выгрузить отчет"
    :visible.sync="_openDialog"
    width="30%"
    center
  >

      <div slot="title" class="title-container" v-if="type_select === 'JOB'">
        <span>Отчеты по работам</span>     <router-link v-if="type_select === 'JOB'" :to="getRoute"><i class="el-icon-tickets"></i></router-link>

      </div>

    <div v-if="type_select === 'PLAN'">
      <el-checkbox v-model="plan.isResource" style="margin-left: 20px" class="mb-1">Ресурсы</el-checkbox>
      <el-checkbox v-model="plan.isTurn" style="margin-left: 20px" class="mb-1">Смены</el-checkbox>
      <el-checkbox v-model="plan.isFact" style="margin-left: 20px" class="mb-1">Факт</el-checkbox>
    </div>
    <div v-else-if="type_select">
      <el-form v-if="type_select === 'DAILY' || type_select === 'DAILY_PLAN'">
        <div class="flex align">
          <date-picker
            :editable="false"
            ref="datePicker"
            placeholder="Фильтр по дате"
            v-model="datetimeRangeDownload[0]"
          ></date-picker>
          <el-checkbox v-model="downloadForAll" style="margin-left: 20px">Все работы</el-checkbox>
        </div>
        <FilterSelect
          v-if="type_select === 'DAILY'"
          hideLabel
          style="max-width: 210px; margin-top: 10px"
          v-model="dayTurn"
          label="Смена"
          :options="turns"
        />
      </el-form>
      <div v-else>
        <date-picker
          v-if="type_select !== 'CHESS' && type_select !== 'TECH_DAY'"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="datetimeRangeDownload"
          range
        ></date-picker>
        <date-picker
          v-if="type_select === 'TECH_DAY'"
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="currentDate"
        ></date-picker>
        <el-row v-if="type_select !== 'CHESS' ">
          <el-col :span="12" v-if="type_select !== 'TECH_DAY'">
            <el-checkbox v-if="type_select !== 'CHESS'" v-model="downloadForAll" style="margin-top: 10px">За все время
            </el-checkbox>
          </el-col>
          <el-col v-if="$route.params.type === 'PROF' && type_select !== 'PROF_BY_JOBS' && type_select !== 'PROF_BY_PLAN'" :span="12">
            <el-checkbox v-model="isProfession" style="margin-top: 10px">По профессиям</el-checkbox>
          </el-col>
          <el-form v-if="type_select === 'PROF_BY_JOBS' || type_select === 'PROF_BY_PLAN'">
            <el-checkbox v-model="isAllCompany" style="margin-top: 10px">Все компании
            </el-checkbox>

            <filter-select v-if="!isAllCompany" :options="companiesOptions" label="Компания" style="margin-bottom: 0; margin-top:0"
                           v-model="companyId"/>
          </el-form>
          <template
            v-if="type_select !== 'WORKS' && type_select !== 'DIR_WORKS' && type_select !== 'PLAN_FACT_INPUTS' && type_select !== 'PROGRESS_BY_INPUT' && type_select !== 'TECH_DAY'  && type_select !== 'JOURNAL_3'">
            <el-col :span="12"
                    v-if="$route.name === 'one-reports-list' && type_select !== 'WORKS' && type_select !== 'FOT' && type_select !== 'DIR_WORKS' && type_select !== 'LOG_JOBS' && this.$store.getters.permission.price && type_select !== 'PLAN_FACT_INPUTS'">
              <el-checkbox @change="changeCheckbox('downloadWithPrice')" v-model="downloadWithPrice"
                           style="margin-top: 10px">
                {{ $store.getters.permission.price && $store.getters.permission.unit_name || 'Стоимость' }}
              </el-checkbox>
            </el-col>
            <el-col :span="12"
                    v-if="$route.name === 'one-reports-list' && type_select === 'JOB'">
              <el-checkbox @change="changeCheckbox('isCurrentPlan')" v-model="isCurrentPlan"
                           style="margin-top: 10px">Текущий план
              </el-checkbox>
            </el-col>
            <el-col :span="12"
                    v-if="$route.name === 'one-reports-list' && type_select !== 'WORKS' && type_select !== 'FOT' && type_select !== 'LOG_JOBS' && type_select !== 'DIR_WORKS' && this.$store.getters.permission.progress ">
              <el-checkbox @change="changeCheckbox('isLaborIntensity')" v-model="isLaborIntensity"
                           style="margin-top: 10px">Трудоемкость
              </el-checkbox>
            </el-col>
          </template>

          <el-col :span="12"
                  v-if="(type_select === 'WORKS' || type_select === 'DIR_WORKS') && this.$store.getters.permission.progress">
            <el-checkbox v-model="isExecutor" style="margin-top: 10px">По исполнителям</el-checkbox>
          </el-col>
        </el-row>
        <div v-else>
          <div style="padding-bottom: 20px; margin-bottom: 4px; border-bottom: 1px solid #eee">
            <el-radio v-model="isCurrentPlan" :label="false">План всего</el-radio>
            <el-radio v-model="isCurrentPlan" :label="true">Текущий план</el-radio>
            <div>
              <el-radio v-model="isCurrentPlan" label="CUSTOM">
                <template>
                  <date-picker
                    :editable="false"
                    ref="datePicker"
                    placeholder="Фильтр по дате"
                    v-model="datetimeRangeDownload"
                    range
                  ></date-picker>
                </template>
              </el-radio>
            </div>
          </div>
          <el-row v-if="type_select !== 'CHESS'">

            <el-col :span="12">
              <el-checkbox @change="changeCheckbox('downloadWithPrice')" v-model="downloadWithPrice"
                           style="margin-top: 10px">По
                {{ $store.getters.permission.price && $store.getters.permission.unit_name || 'Стоимости' }}
              </el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="isLaborIntensity" style="margin-top: 10px">По трудоемкости</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-checkbox v-model="isVolume" style="margin-top: 10px">По физобъемам</el-checkbox>
            </el-col>
            <el-col :span="12" v-if="type_select !== 'CHESS'">
              <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
            </el-col>
          </el-row>

          <el-row v-else>

            <el-col :span="12">
              <el-radio @change="changeChess(downloadWithPrice)" label="downloadWithPrice" v-model="chessRadio"
                        style="margin-top: 10px">По
                {{ $store.getters.permission.price && $store.getters.permission.unit_name || 'Стоимости' }}
              </el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio @change="changeChess(isLaborIntensity)" label="isLaborIntensity" v-model="chessRadio"
                        style="margin-top: 10px">По трудоемкости
              </el-radio>
            </el-col>
            <el-col :span="12">
              <el-radio @change="changeChess(isVolume)" label="isVolume" v-model="chessRadio" style="margin-top: 10px">
                По физобъемам
              </el-radio>
            </el-col>
            <el-col :span="12" v-if="type_select !== 'CHESS'">
              <el-checkbox v-model="downloadForAll" style="margin-top: 10px">За все время</el-checkbox>
            </el-col>
          </el-row>
        </div>

        <el-form v-if="type_select === 'LOG_JOBS'">
          <filter-select :options="exelOptions.dirs" label="Раздел работ" style="margin-bottom: 0; margin-top: 20px"
                         v-model="formExcel.dir"/>
          <filter-select :options="getInputOptions" label="Детализация по полям" v-model="formExcel.details"/>
        </el-form>

        <el-form v-if="type_select === 'PLAN_FACT_INPUTS'">
          <filter-select :options="getAllInputOptions" label="Выберите поле" v-model="formExcel.details"/>

        </el-form>

        <el-form v-if="type_select === 'PROGRESS_BY_INPUT'">
          <filter-select :options="jobOptions" label="Выберите работу" multiple v-model="formExcel.job"
                         style="margin-bottom: -18px; margin-top: 12px"/>

          <filter-select :options="getInputAndMultiOptions" label="Выберите поле" v-model="formExcel.details"/>
        </el-form>
      </div>
      <div  v-if="$store.state.project.plan && $store.state.project.plan.id && (type_select === 'PRICE' || type_select === 'JOB')">
        <el-checkbox v-model="isOnlyPlanFact" style="margin-top: 10px">Только работы с планом и фактом</el-checkbox>
      </div>
    </div>
    <div v-else style="display: flex; justify-content: center; flex-direction: column">
      <template v-if="$route.params.type === 'PROF'">
        <div style="margin-bottom: 10px; width: 100%">
          <el-button style="width: 100%" @click="type_select = 'PROF'">Сводка по численности</el-button>
        </div>
        <div style="margin-bottom: 10px; width: 100%">
          <el-button style="width: 100%" @click="type_select = 'PROF_BY_JOBS'">Численность по видам работ</el-button>
        </div>
        <div style="margin-bottom: 10px; width: 100%">
          <el-button style="width: 100%" @click="type_select = 'PROF_BY_PLAN'">Численность план - факт</el-button>
        </div>
      </template>
      <template v-else>
        <div style="margin-bottom: 10px; width: 100%">
          <el-button style="width: 100%" @click="selectJob('JOB')">Отчеты по работам</el-button>
        </div>

        <div style="margin-bottom: 10px; width: 100%" v-if="$store.state.project.is_fot">
          <el-button style="width: 100%" @click="selectJob('FOT')">Отчеты по ФОТ</el-button>
        </div>
        <template v-if="!$store.state.project.plan || !$store.state.project.plan.id">
          <div style="width: 100%; margin-top: 10px;" v-if="$store.getters.permission.progress">
            <el-button style="width: 100%" @click="type_select = 'WORKS'">Производительность по объектам</el-button>
          </div>
        </template>
      </template>

    </div>
    <span slot="footer" class="dialog-footer" v-if="$route.name !== 'one-reports-list' || type_select">
        <el-button @click="closeDialog">Закрыть</el-button>
        <a :href="getHref" target="_blank" :class="{disabled: !getHref}">
          <el-button type="primary" @click="closeDialog">Выгрузить</el-button>
        </a>
      </span>
  </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import {apiUrl, isApiRuleIgnore} from "../../../../plugins/firebase";
import firebase from "firebase";
import {getDirOptions} from "../../../../firestore/dirs";
import FilterSelect from "../../../../components/FilterSelect";
import DatePicker from "vue2-datepicker";
import {v4 as uuidv4} from "uuid";
import _ from "lodash";
import {getCompaniesOptions} from "../../../../firestore/users";

export default {
  name: "ReportModal",
  props: {
    plan: Object,
    openDialog: false,
    isVersion: Boolean
  },
  components: {FilterSelect, DatePicker},
  data() {
    return {
      turns: [{
        label: 'Весь день',
        value: null,
      },
        {
          label: 'Смена 1',
          value: 1,
        },
        {
          label: 'Смена 2',
          value: 2,
        },
        {
          label: 'Смена 3',
          value: 3,
        }],
      type_select: null,
      downloadWithPrice: false,
      isCurrentPlan: false,
      isLaborIntensity: false,
      isProfession: false,
      chessRadio: 'isVolume',
      jobOptions: [],
      isVolume: false,
      companiesOptions: [],
      isAllCompany: true,
      isOnlyPlanFact: false,
      companyId: null,
      exelOptions: {
        dirs: [],
        details: []
      },
      formExcel: {
        dir: {
          label: 'Все разделы',
          value: null
        },
        details: {
          label: 'Без выбора',
          value: null
        },
        job: [],
      },
      isExecutor: false,
      downloadForAll: false,
      dayTurn: {
        label: 'Весь день',
        value: null,
      },
      currentDate:  new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      datetimeRangeDownload: [
        new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
        new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
      ],
    }
  },
  watch: {
    type_select() {
      if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'day').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      } else {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      }
    }
  },
  async mounted() {
    this.exelOptions.dirs = [{
      label: 'Все разделы',
      value: null
    }, {
      label: 'Без разделов',
      value: 'all'
    }, ...await getDirOptions(this.$store.state.project.id, true)]
    const details = []

    this.companiesOptions = await getCompaniesOptions(this.$store.state.project.id, true)

    myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('inputs')
      .get()
      .then((data) => {
        data.forEach((subDoc) => {
          let _data = subDoc.data();
          details.push({
            ..._data,
            label: _data.name,
            value: subDoc.id || uuidv4(),
          })
        });

        this.exelOptions.details = details
      })

    this.fetchJobs()
  },
  methods: {
    selectJob(type = 'JOB_VERSION') {
      this.type_select = type
      this.downloadForAll = true

      setTimeout(() => {
        this.datetimeRangeDownload = []
      }, 0)
    },
    fetchJobs() {
      const result = [];
      let req = null;
      req = myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .where('type', '==', 'JOB');
      console.log('get jobs 8')

      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              value: subDoc.id,
              label: data.name,
              _data: data,
            });
          });
        })
        .finally(() => {
          this.jobOptions = _.orderBy(result, '_data.index', ['asc']);
        });
    },
    setChess() {
      this.downloadWithPrice = false
      this.isLaborIntensity = false
      this.isVolume = false
      this.chessRadio = 'isVolume'
      this[this.chessRadio] = true

      this.type_select = 'CHESS'
    },
    changeChess() {
      this.downloadWithPrice = false
      this.isLaborIntensity = false
      this.isVolume = false

      this[this.chessRadio] = true
    },
    changeCheckbox(type) {
      if (this.type_select === 'EXECUTOR' || this.type_select === 'EXECUTOR_VERSION') {
        if (type !== 'downloadWithPrice') {
          this.downloadWithPrice = false;
        } else {
          this.isLaborIntensity = false;
        }
      }
    },
    closeDialog() {
      setTimeout(() => {
        this._openDialog = false;
        this.type_select = null;
        this.downloadWithPrice = false;
        this.isLaborIntensity = false;
        this.isProfession = false;
        this.isVolume = false
        this.isExecutor = false;
        this.isAllCompany = true
        this.companyId = null;
        this.downloadForAll = false;
        this.currentDate =  new Date(String(dayjs().utc().format('YYYY-MM-DD')))
        this.dayTurn = {
          label: 'Весь день',
          value: null,
        }
        this.formExcel = {
          dir: {
            label: 'Все разделы',
            value: null
          },
          details: {
            label: 'Без выбора',
            value: null
          },
          job: {
            label: 'Без выбора',
            value: null
          }
        }
      }, 10);
    },
  },
  computed: {
    getInputAndMultiOptions() {
      return this.exelOptions.details.filter((detail) => detail.type && detail.type.value && (detail.type.value.includes('multiple') || detail.type.value.includes('select')))

    },
    getAllInputOptions() {
      return this.exelOptions.details.filter((detail) => detail.type && detail.type.value && (detail.type.value.includes('multiple') || detail.type.value.includes('constructions') || detail.type.value.includes('materials')|| detail.type.value.includes('nomenclature')))
    },
    getInputOptions() {
      const details = this.exelOptions.details.filter((detail) => detail.type && detail.type.value && (detail.type.value.includes('multiple') || detail.type.value.includes('constructions') || detail.type.value.includes('materials')))

      if (this.formExcel.dir && this.formExcel.dir.value) {
        const result = details.filter((detail) => detail.dirs.includes(this.formExcel.dir.value))

        return [
          {
            label: 'Без выбора',
            value: null
          },
          ...result,
        ]
      }

      return details
    },
    _openDialog: {
      get() {
        return this.openDialog;
      },
      set(e) {
        if (!e) {
          this.$emit('close')
        }
      }
    },
    getRoute() {
      let url =  '/dashboard/jobs-report?s=l';
      if(!this.downloadForAll && this.datetimeRangeDownload[0]) {
        const fromDate = dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')
        const toDate = dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')
        url += `&fromDate=${fromDate}&toDate=${toDate}`
      }

      if(this.downloadWithPrice) {
        url +=  `&isPrice=true`

      }

      if(this.isLaborIntensity) {
        url +=  `&isLaborIntensity=true`
      }

      return url
    },
    getHref() {
      const types = {
        'JOB': 'onGenerateFactJobs',
        'PROF': 'onGenerateHeadcount',
        'PROF_BY_JOBS': 'onGenerateWorkerHeadcountExcel',
        'PROF_BY_PLAN': 'onGenerateWorkerHeadcountByPlanExcel',
        'TECH': 'onGenerateTechnical',
        'COVID': 'onGenerateTemperature',
        'WILD_PIPE': 'onGenerateWelding',
        'MATERIALS': 'onGenerateMaterial',
        'MAIN': 'onGenerateMainJobs',
        'DAILY_PLAN': 'onGenerateDailyJobs',
        'DAILY': 'onGenerateDailyReportsJobs',
        'PRICE': 'onGeneratePriceJobs',
        'PLAN': 'onGeneratePlanMonthlyJobs',
        'WORKS': 'onGenerateProductivityLaborIntensityJobsObjects',
        'DIR_WORKS': 'onGenerateProductivityLaborIntensityJobsDirs',
        'DIR_PROGRESS': 'onGenerateProgressPriceLaborIntensityJobsDirs',
        'LOG_JOBS': 'onGenerateLogJobsByDirs',
        'PRICE_VERSION': 'onGeneratePriceJobsByVersionPlan',
        'JOB_VERSION': 'onGenerateFactJobsByVersionPlan',
        'EXECUTOR': 'onGenerateExecutorsJobs',
        'EXECUTOR_VERSION': 'onGenerateExecutorsJobsByVersionPlan',
        'DIR_WORKS_VERSION': 'onGenerateProductivityLaborIntensityJobsDirsByVersionPlan',
        'PLAN_FACT_INPUTS': '',
        'CHESS': 'onGenerateCheckboardJobs',
        'CHESS_VERSION': 'onGenerateCheckboardJobsByVersionPlan',
        'PROGRESS_BY_INPUT': 'onGenerateInputsByJobs',
        'TECH_DAY': 'onGenerateMachineryIBCMUploadDailyReportExcel',
        'JOURNAL_3': 'onGenerateProfDevelopingPolicyMonthlyPlanExcel',
        'FOT': 'onGenerateFotJobsByExecutors'
      };


      if(this.type_select === 'TECH_DAY') {
        const fromDate = dayjs(this.currentDate).format('YYYY-MM-DD')
        const project = this.$store.state.project.id;

        const uid = this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid

        let url = `${apiUrl}/onGenerateMachineryIBCMUploadDailyReportExcel%3FprojectId%3D${project}%26uid%3D${uid}`

        if(!this.downloadForAll) {
          url += `%26fromDate%3D${fromDate}`
        }

        if (isApiRuleIgnore) {
          url = url.replace(/ ,/g, "?");
        }

        if(isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }

        return url
      }

      if(this.type_select === 'PROF_BY_JOBS' || this.type_select === 'PROF_BY_PLAN') {
        const fromDate = dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')
        const toDate = dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')
        const project = this.$store.state.project.id;

        const uid = this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid


        let url = `${apiUrl}/onGenerateWorkerHeadcountExcel%3FprojectId%3D${project}%26uid%3D${uid}%26isProfession%3Dtrue`

        if(this.type_select === 'PROF_BY_PLAN') {
          url = `${apiUrl}/onGenerateWorkerHeadcountByPlanExcel%3FprojectId%3D${project}%26uid%3D${uid}`
        }
        // %26userId%3D${}

        if(!this.isAllCompany) {
          if (this.companyId && this.companyId.value) {
            url += `%26userId%3D${this.companyId.value}`
          } else {
            return null
          }
        }


        if (isApiRuleIgnore) {
          url = url.replace('&queryParams=', '?').replace(/, /g, "&")
        }

        if(!this.downloadForAll) {
          url += `%26fromDate%3D${fromDate}%26toDate%3D${toDate}`
        }


        if (isApiRuleIgnore) {
          url = url.replace(/ ,/g, "?");
        }

        if(isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }

        return url
      }

      let path = types[this.type_select === 'DAILY' ? 'DAILY' : (this.$route.params.type || 'JOB')]


      if (this.downloadWithPrice) {
        path = types['PRICE'];
      }

      if (this.type_select === 'DAILY_PLAN') {
        path = types['DAILY_PLAN']
      }

      if (this.type_select === 'CHESS') {
        path = types['CHESS']
      }

      if (this.type_select === 'PLAN') {
        path = types['PLAN']
      }

      if (this.type_select === 'WORKS') {
        path = types['WORKS']
      }

      if (this.type_select === 'DIR_WORKS') {
        path = types['DIR_WORKS']
      }

      if (this.type_select === 'DIR_PROGRESS') {
        path = types['DIR_PROGRESS']
      }

      if (this.type_select === 'LOG_JOBS') {
        path = types['LOG_JOBS']
      }

      if (this.type_select === 'JOB_VERSION') {
        path = types['JOB_VERSION'];
      }

      if (this.type_select === 'EXECUTOR') {
        path = types['EXECUTOR'];
      }

      if (this.type_select === 'EXECUTOR_VERSION') {
        path = types['EXECUTOR_VERSION'];
      }

      if (this.type_select === 'PROGRESS_BY_INPUT') {
        path = types['PROGRESS_BY_INPUT'];
      }


      if (this.type_select === 'JOB_VERSION') {
        path = types['JOB_VERSION'];
      }

      if (this.type_select === 'FOT') {
        path = types['FOT'];
      }


      if (this.downloadWithPrice && (this.$store.state.project.version && this.$store.state.project.version.id)) {
        path = types['PRICE_VERSION'];
      }


      if (this.type_select === 'CHESS' && (this.$store.state.project.version && this.$store.state.project.version.id)) {
        path = types['CHESS_VERSION'];
      }

      if (this.type_select === 'DIR_WORKS' && (this.$store.state.project.version && this.$store.state.project.version.id)) {
        path = types['DIR_WORKS_VERSION'];

      }

      if (this.type_select === 'PLAN_FACT_INPUTS') {
        const urls = {
          'materials': 'onGenerateMaterialsByInputs',
          'constructions': 'onGenerateConstructionsByInputs',
          'multiple': 'onGenerateMultiplesByInputs',
          'nomenclature': 'onGenerateNomenclaturesByInputs'
        }

        const detail = this.exelOptions.details.find(({value}) => value === this.formExcel.details.value)
        if (detail) {
          path = urls[detail.type.value.replace('L', '')]
        } else {
          return ''
        }
      }

      if (this.type_select === 'EXECUTOR_VERSION') {
        path = types['EXECUTOR_VERSION'];
      }


      if(this.$store.state.project.name.toLowerCase() === 'все проекты' && this.type_select === 'JOB') {
        path = `onGenerateJobsByProjects`
      }

      const params = encodeURIComponent(`/${path}/${this.$store.state.project.id}`)
      let url = `${apiUrl}${params}&queryParams=uid=${this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid}`;
      if (isApiRuleIgnore) {
        const params = `/${path}/${this.$store.state.project.id}`
        url = `${apiUrl}${params}?uid=${this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid}`;
      }

      // if (this.type_select === 'DIR_PROGRESS' && this.$store.state.project.plan && this.$store.state.project.plan.id) {
      //   url += `, planId=${this.$store.state.project.plan.id}`
      // }



      if (this.type_select === 'PLAN') {
        url += `, planId=${this.$store.state.project.plan.id}`
        if (this.plan.isFact) {
          url += `, isFact=true`
        }

        if (this.isCurrentPlan === true) {
          url += `, isCurrentPlan=${true}`
        }


        if (this.plan.isResource) {
          url += `, isResource=true`
        }

        if (this.plan.isTurn) {
          url += `, isTurn=true`

        }

        if (isApiRuleIgnore) {
          url = url.replace(/ ,/g, "?");
        }

        if (isApiRuleIgnore) {
          url = url.replace(/, /g, "&");
        }


        if(isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }

        return url
      }


      if (this.type_select === 'PROGRESS_BY_INPUT') {
        if (!this.formExcel.details.value || !this.formExcel.job.length) {
          return null
        }
        if (this.formExcel.details.value) {
          url += `, inputId=${this.formExcel.details.value}`;
        }

        if (this.formExcel.job.length) {
          url += `, jobsIds=${this.formExcel.job.map(({value}) => value).join(',')}`;
        }

        if (this.downloadForAll) {
          url += `, isAllPlan=true`;
        }
      }

      if (this.type_select === 'LOG_JOBS') {
        if (this.formExcel.dir.value) {
          url += `, dir=${this.formExcel.dir.value}`;
        }

        if (this.formExcel.details.value) {
          url += `, details=${this.formExcel.details.value}`;
        }
      }

      if (this.type_select === 'PLAN_FACT_INPUTS') {
        if (this.formExcel.details && this.formExcel.details.value) {
          url += `, inputId=${this.formExcel.details.value}`;
        }
      }


      if (this.type_select === 'JOURNAL_3') {
        const fromDate = dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')
        const toDate = dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')
        const project = this.$store.state.project.id;
        const uid = this.$store.state.company.uid || this.$store.state.company.id || authFirestore.currentUser.uid

        let url = ``

        if(this.type_select === 'JOURNAL_3') {
          url = `${apiUrl}/onGenerateSection3GeneralWorkLogGWL%3FprojectId%3D${project}%26uid%3D${uid}`
        }

        if (isApiRuleIgnore) {
          url = url.replace('&queryParams=', '?').replace(/, /g, "&")
        }

        if (!this.downloadForAll) {
          url += `%26fromDate%3D${fromDate}%26toDate%3D${toDate}`
        }


        if (isApiRuleIgnore) {
          url = url.replace(/ ,/g, "?");
        }

        if (isApiRuleIgnore) {
          url = decodeURIComponent(url)
        }

        return url
      }

      if (!this.downloadForAll && this.type_select !== 'DAILY') {
        if(this.datetimeRangeDownload[0]) {

          url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
        }
      } else if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        if(this.datetimeRangeDownload[0]) {

          url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}`;
        }
      }
      if (this.dayTurn.value) {
        url += `, turn=${this.dayTurn.value}`;
      }

      if (this.type_select === 'CHESS') {
        if (this.isCurrentPlan === false) {
          url += `, isAllPlan=${true}`
        }
      }

      if (this.isCurrentPlan === true) {
        url += `, isCurrentPlan=${true}`
      }

      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        url += `, planId=${this.$store.state.project.plan.id}`;
      }


      if (this.downloadForAll) {
        url += `, isAllJobs=true`;
      }

      if (this.isProfession) {
        url += `, isProfession=true`;
      }

      if (this.isLaborIntensity) {
        url += `, isLaborIntensity=true`;
      }

      if (this.isVolume) {
        url += `, isVolume=true`;
      }

      if (this.isExecutor) {
        url += `, isExecutor=true`;
      }

      if (this.downloadWithPrice) {
        url += `, isPrice=true`;

      }

      if (this.$store.state.project.version && this.$store.state.project.version.id) {
        url += `, planId=${this.$store.state.project.version.id}`
      }

      if(this.isOnlyPlanFact) {
        url += `, isOnlyPlanFact=true`

      }

      if (this.downloadForAll && (this.type_select === 'JOB' || this.type_select === 'PRICE')) {
        url += `, isAllDates=true`;
        if(this.datetimeRangeDownload[0]) {
          url += `, fromDate=${dayjs(this.datetimeRangeDownload[0]).format('YYYY-MM-DD')}, toDate=${dayjs(this.datetimeRangeDownload[1]).format('YYYY-MM-DD')}`;
        }
      }

      if(isApiRuleIgnore) {
        url = decodeURIComponent(url)
      }



      if (isApiRuleIgnore) {
        url = url.replace(/, /g, "&");
      }

      if(isApiRuleIgnore) {
        url = decodeURIComponent(url)
      }
      return url;
    },
  }
}
</script>

<style scoped lang="scss">
.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-icon-tickets {
  font-size: 24px;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/ReportModal.vue